import { runAfterInitialRender } from 'owa-delayed-initialization';

export type PreloadResourceType =
    | 'audio'
    | 'font'
    | 'image'
    | 'media'
    | 'script'
    | 'style'
    | 'track'
    | 'video';

export function preloadResource(resource: string, resourceType: PreloadResourceType) {
    if (process.env._SERVERLESS_) {
        // Most script bundles don't exist in storybook builds,
        // so we shouldn't try to preload them
        return;
    }

    runAfterInitialRender(() => {
        if (document.head.querySelectorAll(`*[src='${resource}'],*[href='${resource}']`).length) {
            // Don't prefetch if we've already requested the resource
            return;
        }

        let link = document.createElement('link');
        link.href = resource;
        link.rel = 'prefetch';
        // Our types aren't yet updated to include the 'as' property of HTMLLinkElement
        (<any>link).as = resourceType;

        document.head.appendChild(link);
    });
}
